<template>
  <div class="c-overlay-wrapper">
    <div class="c-content-wrapper">
      <div class="c-splash-loader-lines"></div>
      <div class="c-loading-txt">Učitavanje podataka..  </div>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverlayLoader',
  props: [],
  data () {
    return {
      msg: 'Dummy',
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/helpers/OverlayLoader.vue